import { axios } from '@/lib/axios';
import { API_URL_MAIN } from '@/config';

export type I_SignUp = {
  login_id: string;
  password: string;
  token: string;
};

export type I_SignUpResponse = {
  error_code: string;
  error_msg: any;
};

export const signUp = (data: I_SignUp): Promise<I_SignUpResponse> => {
  return axios.post(`${API_URL_MAIN}/sign_up`, data);
};
